import { render, staticRenderFns } from "./Suffix.vue?vue&type=template&id=65492c8f&scoped=true&"
import script from "./Suffix.vue?vue&type=script&lang=js&"
export * from "./Suffix.vue?vue&type=script&lang=js&"
import style0 from "../ThemeSettingsChildren.css?vue&type=style&index=0&id=65492c8f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65492c8f",
  null
  
)

export default component.exports